module.exports = __webpack_public_path__ + "img/logo.6c56a23c.png";